import ExtendableError from 'es6-error';

class JobError extends ExtendableError {
  // constructor is optional; you should omit it if you just want a custom error
  // type for inheritance and type checking
  constructor(message, job) {
    super(message);
    this.job = job;
  }
}

export default JobError;